const vaildateErrorCode = (errorCode) => {
  switch (String(errorCode)) {
    case '01': {
      return 'ขออภัย บัตรของคุณไม่สามารถทำรายการได้ กรุณาติดต่อธนาคารของคุณ'
    }
    case '05': {
      return 'ขออภัย ไม่สามารถทำธุรกรรมได้ กรุณาติดต่อธนาคารของคุณ'
    }
    case '13': {
      return 'ขออภัย ธุรกรรมไม่ถูกต้อง กรุณาทำรายการใหม่อีกครั้งหรือติดต่อเจ้าหน้าที่'
    }
    case '14': {
      return 'ขออภัย เลขบัตรของคุณไม่ถูกต้อง กรุณาติดต่อธนาคารของคุณ'
    }
    case '34': {
      return 'ขออภัย บัตรของคุณหมดอายุ กรุณาติดต่อธนาคารของคุณ'
    }
    case '50': {
      return 'ขออภัย มีบางอย่างผิดพลาด กรุณาทำรายการใหม่อีกครั้ง'
    }
    case '51': {
      return 'ขออภัย บัตรของคุณมียอดวงเงินคงเหลือไม่เพียงพอสำหรับการชำระเงิน กรุณาติดต่อธนาคารของคุณ'
    }
    case '54': {
      return 'ขออภัย บัตรของคุณหมดอายุ กรุณาติดต่อธนาคารของคุณ'
    }
    case '55': {
      return 'ขออภัย เลข OTP ไม่ถูกต้อง กรุณาทำรายการใหม่อีกครั้ง'
    }
    case '500': {
      return 'ขออภัย คุณไม่สามารถทำรายการภายในระยะเวลาที่กำหนด กรุณาทำรายการใหม่อีกครั้ง'
    }
    case 'card_invalid': {
      return 'ขออภัย บัตรของคุณไม่สามารถทำรายการได้ กรุณาติดต่อธนาคารของคุณ'
    }
    case 'pending_state': {
      return 'ขออภัย สถานะธุรกรรมรอดำเนินการ กรุณาทำรายการอีกครั้งใน 15 นาที'
    }
    case 'foreign_card_not_supported': {
      return 'ขออภัย ระบบไม่รองรับบัตรเครดิตประเภทนี้'
    }
    case 'currency_invalid': {
      return 'ขออภัย ระบบไม่รองรับสกุลเงินนี้ในปัจจุบัน'
    }
    case 'card_not_verified': {
      return 'ขออภัย บัตรของคุณไม่ได้ลงทะเบียนใช้บริการ กรุณาติดต่อธนาคารของคุณ'
    }
    case 'invalid_txn_amount': {
      return 'ขออภัย ธุรกรรมไม่ถูกต้อง กรุณาทำรายการใหม่อีกครั้งหรือติดต่อเจ้าหน้าที่'
    }
    default: {
      return `ขออภัย มีบางอย่างผิดพลาด (Error Code: ${errorCode})`
    }
  }
}

export default {
  vaildateErrorCode
}
